module.exports = __webpack_public_path__ + "static/img/protection-landing.81b1afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protection-landing.png
// module id = 140
// module chunks = 0